const notificationAudio = new Audio("/notification.mp3");

notificationAudio.preload = "auto";
notificationAudio.volume = 1;

export const playNotificationSound = async () => {
  console.log("playNotificationSound called");
  try {
    // notificationAudio.pause();
    notificationAudio.currentTime = 0;
    await notificationAudio.play();
  } catch (err) {
    console.warn("Unable to play notification sound:", err);
  }
};
